import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { createSelector } from 'reselect';

import { Student } from 'common.components/typings';
import { getStudentIdFromProps } from 'utils/selectors/selectors';

import { StudentsStoreState, StudentValidation } from './typings';

export const studentsStateSelector = (store: any): StudentsStoreState => store.students;

export const getNewStudent = createSelector(
    studentsStateSelector,
    (storeState): Student | null => storeState.newStudent
);

export const getIsAddingNewStudent = createSelector(
    studentsStateSelector,
    (storeState): boolean => storeState.isAddingNewStudent
);

export const getCurrentEditingStudentIndex = createSelector(
    studentsStateSelector,
    (storeState): number | null => storeState.currentEditingStudentIndex
);

export const getIsStudentEditing = createSelector(
    [getCurrentEditingStudentIndex, getStudentIdFromProps],
    (currentEditingStudent, studentId): boolean => {
        if (!currentEditingStudent || !studentId) {
            return false;
        }

        return currentEditingStudent === studentId;
    }
);

export const getNewStudentEditingStudentName = createSelector(
    [studentsStateSelector, getCurrentEditingStudentIndex],
    (storeState, currentEditingStudent): string | null => {
        if (currentEditingStudent) {
            return null;
        }

        return storeState.editingStudentNames[0];
    }
);

export const getEditStudentNameStatus = createSelector(
    studentsStateSelector,
    (storeState): LOADING_STATUSES => storeState.editStudentNameStatus
);

export const getCurrentEditingStudentName = createSelector(
    [studentsStateSelector, getStudentIdFromProps],
    (storeState, studentId: number): string => storeState.editingStudentNames[studentId]
);

export const getSubmittingStatus = createSelector(
    studentsStateSelector,
    (storeState): boolean => storeState.submitting
);

export const getIsRequestingLogin = createSelector(
    studentsStateSelector,
    (storeState): boolean => storeState.requestingLogin
);

export const getControlsStatus = createSelector(
    studentsStateSelector,
    (storeState): boolean => storeState.controlsStatus
);

export const getUsersConvertionStatus = createSelector(
    studentsStateSelector,
    (storeState): LOADING_STATUSES => storeState.convertPassportsStatus
);

export const getCurrentPassportChangeStudentIndex = createSelector(
    studentsStateSelector,
    (storeState): number | null => storeState.currentPassportChangeStudentIndex
);

export const getStudentChangePassportStatus = createSelector(
    studentsStateSelector,
    (storeState): LOADING_STATUSES => storeState.studentChangePassportStatus
);

export const getMigratingStudents = createSelector(
    studentsStateSelector,
    (storeState): Record<number, StudentValidation> => storeState.migratingStudents
);

export const getStudentValidationById = createSelector(
    [getMigratingStudents, getStudentIdFromProps],
    (migratingStudents, id): StudentValidation | null => (id ? migratingStudents[id] : null)
);
